import { render } from "./index.vue?vue&type=template&id=d2a36b82&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d2a36b82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d2a36b82"

export default script